<div
  class="ui-progress-bar"
  role="progressbar"
  [class.ui-progress-bar-neutral]="isNeutral()"
  [class.ui-progress-bar-info]="isInfo()"
  [class.ui-progress-bar-success]="isSuccess()"
  [class.ui-progress-bar-warning]="isWarning()"
  [class.ui-progress-bar-danger]="isDanger()"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="normalizedMax()"
  [attr.aria-valuenow]="normalizedValue()"
>
  <span
    class="ui-progress-bar-fill"
    [style.inline-size.%]="progressPercent()"
  ></span>
</div>
@if (showValue()) {
  <span class="ui-progress-bar-value">{{ progressText() }}</span>
}
